import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/WebcastDbosConductorIntroPage.head';
import { WebcastDbosConductorIntroPage } from '@pages/WebcastDbosConductorIntroPage';

export const Route = createFileRoute('/webcast-dbos-conductor-intro')({
  component: WebcastDbosConductorIntroPage,
  head: () => head,
});
